import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { ButtonStyle } from "../../js/enums";
import { Button } from "../elements/_CommonElements";

function NavigationLink({
  className,
  disabled,
  text,
  to,
  openInNewTab,
  url,
}) {
  if (disabled) {
    return (
      <li>
        <Button
          className={classNames(
            className,
            "nav-link",
            "disabled",
            "text-muted"
          )}
          disabled
          style={ButtonStyle.Link}
          text={text}
        />
      </li>
    );
  }

  return (
    <li>
      <NavLink
        to={openInNewTab && url ? url : to}
        className={({ isActive }) =>
          classNames(className, isActive ? "active" : "", "nav-link")
        }
        state={{
          canGoBack: true,
        }}
        target={openInNewTab ? "_blank" : ""}
        rel={openInNewTab ? "noreferrer" : ""}
      >
        {text}
      </NavLink>
    </li>
  );
}

export default NavigationLink;
